import React, { useState } from "react";

export default function POSScene({ onComplete }: { onComplete: () => void }) {
  const [isTapping, setIsTapping] = useState(false);

  const handleTap = () => {
    setIsTapping(true);
    
    // Simulate Lottie animation duration
    setTimeout(() => {
      onComplete();
    }, 2500); 
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Simulate Transaction</h1>
      <p style={styles.subtitle}>Hold your card near the terminal to begin.</p>

      <div style={styles.content}>
        <div style={styles.animationArea}>
          <iframe 
            src="/assets/tap_and_pay_asset.html" 
            title="Tap and Pay Animation"
            style={styles.iframe}
            scrolling="no"
          />
        </div>
        
        <button style={styles.tapButton} onClick={handleTap} disabled={isTapping}>
          {isTapping ? "Processing..." : "Tap Card to Terminal"}
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: 600,
    margin: "0 auto",
    textAlign: "center"
  },
  title: {
    fontSize: "clamp(24px, 4vw, 36px)",
    fontWeight: 700,
    color: "#FFFFFF",
    marginBottom: 8
  },
  subtitle: {
    fontSize: 16,
    color: "#94A3B8",
    marginBottom: 40
  },
  content: {
    background: "rgba(15, 23, 42, 0.6)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(148, 163, 184, 0.15)",
    borderRadius: 24,
    padding: 40,
    width: "100%",
    maxWidth: 400,
    boxShadow: "0 20px 40px rgba(0,0,0,0.5)"
  },
  animationArea: {
    height: 300,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
    borderRadius: 16,
    overflow: "hidden"
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    transform: "scale(1.2)",
    transformOrigin: "center"
  },
  tapButton: {
    background: "linear-gradient(90deg, #3ba4f7, #00e0ff)",
    border: "none",
    color: "#000000",
    padding: "16px 32px",
    borderRadius: 30,
    fontSize: 18,
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: "0 10px 30px rgba(56, 189, 248, 0.3)",
    transition: "all 0.2s ease",
    width: "100%"
  }
};
